module.exports = __webpack_public_path__ + "img/start-ups.32e1a371.svg";